import { Component, OnInit } from '@angular/core';
import {ModalController, NavParams} from "@ionic/angular";
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-info-product',
  templateUrl: './info-product.component.html',
  styleUrls: ['./info-product.component.scss'],
})
export class InfoProductComponent implements OnInit {
  product: any;
  private actionUrl = environment.baseUrlPuclic;

  constructor(public navParams: NavParams, private modalCtrl: ModalController) {
    this.product = this.navParams.get('product');

  }

  ngOnInit() {}
  cancel(){
    this.modalCtrl.dismiss();
  }
}
